import React, { useEffect, useState } from "react";
import { Row, Col, Form, Modal, Spinner } from "react-bootstrap";
// import Select from "react-select";



const MODAL_STYLES = `
  .edit-product-modal {
    z-index: 1055 !important;
  }
  .edit-product-modal .modal-dialog {
    z-index: 1056 !important;
  }
  .modal-backdrop {
    z-index: 1050 !important;
  }

  .edit-product-modal .modal-content {
    border: none;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18);
  }

  .edit-product-modal .modal-header .btn-close {
    filter: invert(1) brightness(2);
    opacity: 0.85;
  }
  .edit-product-modal .modal-header .btn-close:hover {
    opacity: 1;
  }

  /* ── Info tiles (read-only) ── */
  .epm-info-tile {
    background: #f8fafc;
    border: 1px solid #e8edf3;
    border-radius: 8px;
    padding: 9px 12px;
  }
  .epm-info-tile .tile-label {
    font-size: 10.5px;
    color: #8a94a6;
    letter-spacing: 0.03em;
    margin-bottom: 2px;
    text-transform: uppercase;
  }
  .epm-info-tile .tile-value {
    font-size: 13px;
    font-weight: 600;
    color: #2d3748;
  }

  /* ── Section divider ── */
  .epm-section-label {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #8a94a6;
    margin-bottom: 12px;
    margin-top: 4px;
  }
  .epm-section-label::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #e8edf3;
  }

  /* ── Form inputs ── */
  .epm-body .form-control,
  .epm-body .form-select {
    font-size: 13px;
    border: 1px solid #dce3ec;
    border-radius: 8px;
    padding: 8px 11px;
    color: #2d3748;
    background: #ffffff;
    transition: border-color 0.15s, box-shadow 0.15s;
  }
  .epm-body .form-control:focus,
  .epm-body .form-select:focus {
    border-color: #00BBBB;
    box-shadow: 0 0 0 3px rgba(0, 187, 187, 0.12);
    outline: none;
  }
  .epm-body .form-label {
    font-size: 12px;
    font-weight: 600;
    color: #4a5568;
    margin-bottom: 5px;
  }
  .epm-body textarea.form-control {
    resize: vertical;
    min-height: 70px;
  }

  /* ── Status toggle row ── */
  .epm-status-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f8fafc;
    border: 1px solid #e8edf3;
    border-radius: 10px;
    padding: 12px 14px;
  }
  .epm-toggle-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .epm-status-badge {
    font-size: 11.5px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 20px;
  }
  .epm-status-badge.active {
    background: #d1fae5;
    color: #065f46;
  }
  .epm-status-badge.inactive {
    background: #fee2e2;
    color: #991b1b;
  }

  /* ── Toggle switch ── */
  .epm-switch {
    position: relative;
    display: inline-block;
    width: 42px;
    height: 24px;
    cursor: pointer;
  }
  .epm-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .epm-slider {
    position: absolute;
    inset: 0;
    background: #cbd5e0;
    border-radius: 24px;
    transition: background 0.2s;
  }
  .epm-slider::before {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    background: #fff;
    border-radius: 50%;
    top: 3px;
    left: 3px;
    transition: transform 0.2s;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  }
  .epm-switch input:checked + .epm-slider {
    background: #00BBBB;
  }
  .epm-switch input:checked + .epm-slider::before {
    transform: translateX(18px);
  }

  /* ── Footer ── */
  .edit-product-modal .modal-footer {
    background: #f8fafc;
    border-top: 1px solid #e8edf3;
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .epm-footer-meta {
    font-size: 12px;
    color: #a0aec0;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .epm-cancel-btn {
    background: none;
    border: 1px solid #dce3ec;
    border-radius: 8px;
    padding: 8px 18px;
    font-size: 13px;
    font-weight: 500;
    color: #4a5568;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
  }
  .epm-cancel-btn:hover {
    background: #f0f4f8;
    border-color: #b8c3d0;
  }
  .epm-save-btn {
    background: #00BBBB;
    border: none;
    border-radius: 8px;
    padding: 8px 22px;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    min-width: 140px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    transition: background 0.15s, transform 0.1s;
  }
  .epm-save-btn:hover:not(:disabled) {
    background: #00a3a3;
  }
  .epm-save-btn:active:not(:disabled) {
    transform: scale(0.98);
  }
  .epm-save-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  /* ── Body scroll ── */
  .epm-body {
    background: #ffffff;
    max-height: 72vh;
    overflow-y: auto;
    padding: 20px 24px;
    scrollbar-width: thin;
    scrollbar-color: #dce3ec transparent;
  }
  .epm-body::-webkit-scrollbar { width: 5px; }
  .epm-body::-webkit-scrollbar-track { background: transparent; }
  .epm-body::-webkit-scrollbar-thumb { background: #dce3ec; border-radius: 3px; }
`;
const EditCustomer = ({ show, onHide, rowData, onSave }) => {
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);
  // const [filerStatus, setFilerStatus] = useState(formData.filerStatus === "Active" ? true : formData.filerStatus === "Inactive" ? false : null);

  useEffect(() => {
    if (rowData) {
      setFormData({
        name: rowData.name || "",
        phone: rowData.phone || "",
        email: rowData.email || "",
        address: rowData.address || "",
        filerStatus: rowData.filerStatus ?? null,
      });
    }
  }, [rowData]);

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSave = async () => {
    setSaving(true);
    await onSave({ ...rowData, ...formData });
    setSaving(false);
    onHide();
  };


  // const getStatusList = [
  //     { value: true, label: "Active" },
  //     { value: false, label: "Non Active" },
  // ];
  // const handleChangeStatus = (selectedOption) => {
  //     setFilerStatus(selectedOption.value);
  // };

  return (
    <>
      <style>{MODAL_STYLES}</style>

      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        className="edit-product-modal"
        container={document.body}
      >
        {/* ── Header ── */}
        <Modal.Header
          closeButton
          style={{
            background: "linear-gradient(120deg, #00BBBB 0%, #009999 100%)",
            padding: "16px 20px",
            borderBottom: "none",
          }}
        >
          <Modal.Title style={{ fontSize: "1rem" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div
                style={{
                  width: 36, height: 36, borderRadius: "50%",
                  background: "rgba(255,255,255,0.2)",
                  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </div>
              <div>
                <div style={{ color: "#fff", fontWeight: 600, fontSize: 14, lineHeight: 1.2 }}>Edit Shop</div>
                <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 12, fontWeight: 400 }}>{formData.name || "Loading…"}</div>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>

        {/* ── Single-page body ── */}
        <Modal.Body className="epm-body p-0">
          <div style={{ padding: "20px 24px" }}>
            <Row className="g-3 mb-3">
              <Col sm={6} md={4}>
                <Form.Group controlId="editName">
                  <Form.Label>Customer Name</Form.Label>
                  <Form.Control type="text" placeholder="Customer name" value={formData.name} onChange={handleChange("name")} />
                </Form.Group>
              </Col>
              <Col sm={6} md={4}>
                <Form.Group controlId="editCode">
                  <Form.Label>Customer Phone</Form.Label>
                  <Form.Control type="text" placeholder="Customer phone" value={formData.phone} onChange={handleChange("phone")} />
                </Form.Group>
              </Col>
              <Col sm={6} md={4}>
                <Form.Group controlId="editBarcode">
                  <Form.Label>Customer Email</Form.Label>
                  <Form.Control type="text" placeholder="Customer email" value={formData.email} onChange={handleChange("email")} />
                </Form.Group>
              </Col>
            </Row>
            <Row className="g-3 mb-3">
              <Col sm={6} md={4}>
                <Form.Group controlId="editDesc">
                  <Form.Label>Customer Address</Form.Label>
                  <Form.Control type="text" placeholder="Customer address" value={formData.address} onChange={handleChange("address")} />
                </Form.Group>
              </Col>
              {/* <Col>
                                <Form.Group controlId="editFilerStatus">
                                    <Form.Label>Filer Status</Form.Label>
                                    <Select
                                        placeholder="Select Filer Status"
                                        onChange={handleChangeStatus}
                                        options={getStatusList}
                                        value={getStatusList.find(opt => opt.value === filerStatus) || null}
                                    />
                                </Form.Group>
                            </Col> */}
            </Row>

          </div>
        </Modal.Body>

        {/* ── Footer ── */}
        <Modal.Footer>
          <div className="epm-footer-meta">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            Make sure to review all details before confirming.
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="epm-cancel-btn" onClick={onHide}>Cancel</button>
            <button className="epm-save-btn" onClick={handleSave} disabled={saving}>
              {saving ? (
                <><Spinner as="span" animation="border" size="sm" />Saving…</>
              ) : (
                <>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  Save changes
                </>
              )}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditCustomer;